var root=require("./_root"),now=function(){return root.Date.now()};module.exports=now;